import { useOutletContext } from "react-router-dom";
import MobileForm from "./components/mobile-form";
import WebForm from "./components/web-form";
import React from "react";

export default function LearnerForm() {
	const [handleChangeWebStyleLayout, layout] = useOutletContext();

	return (
		<React.Fragment>
			{layout === "mobile" 
				? <MobileForm />
				: <WebForm onChangeWebStyleLayout={handleChangeWebStyleLayout}/>
			}
		</React.Fragment>
	);
}
